import { Menu, MenuItem } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  LeftBar,
  TopBar,
  NavBarBody,
  Icon,
  LeftBarCategory,
  LeftBarSubCategory,
  Category,
  ThemeSwitch,
  UserIcon,
  UserTitle,
  UserDiv,
} from "./styles";
import MaterialUISwitch from "./Switch";
import { UserPermissions } from "../../App";

interface Props {
  userPermissions: UserPermissions;
  setDarkMode: any;
  setUserPermissions: any;
}
const NavBar: React.FC<Props> = ({
  userPermissions,
  setDarkMode,
  setUserPermissions,
}) => {
  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [accountInfo, setAccountInfo] = useState({
    logo: "",
    username: "",
  });
  const getMyAccountInfo = () => {
    fetch("/api/v1/account/myAccount", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success === true) {
          setAccountInfo({
            logo: data.logo,
            username: data.username,
          });
          setUserPermissions({
            ORI: {
              Admin: data.isAdmin,
              Researcher: data.isResearcher,
            },
            OrgAdmin: data.organizationRoles.admin,
            OrgClinical: data.organizationRoles.clinical,
            OrgDeveloper: data.organizationRoles.developer,
          });
        }
      });
  };
  useEffect(() => {
    getMyAccountInfo();
    const interval = setInterval(() => {
      getMyAccountInfo();
    }, 5000);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const changePage = (nextUrl = "/") => {
    navigate(process.env.PUBLIC_URL + nextUrl);
  };

  const handleLogout = () => {
    handleClose();
    fetch("/api/v1/account/auth/logout", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  };

  return (
    <NavBarBody>
      {/* Top Bar */}
      <TopBar>
        <UserDiv
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={(event: any) => {
            handleClick(event);
          }}
        >
          <UserTitle>{accountInfo.username || "Loading"}</UserTitle>
          {accountInfo.logo && <UserIcon src={accountInfo.logo} />}
        </UserDiv>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          <MenuItem
            onClick={() => {
              handleClose();
              changePage("/MyAccount");
            }}
          >
            My account
          </MenuItem>
          <MenuItem onClick={handleLogout}>Logout</MenuItem>
        </Menu>
      </TopBar>
      {/* Left Bar */}
      <LeftBar>
        <Icon
          src={process.env.PUBLIC_URL + "/img/icon.png"}
          onClick={() => changePage("/")}
        />
        {(userPermissions.ORI.Admin || userPermissions.OrgAdmin.length > 0) && (
          <Category>
            <LeftBarCategory>Admin</LeftBarCategory>
            {userPermissions.ORI.Admin && (
              <LeftBarSubCategory onClick={() => changePage("/Users")}>
                Users
              </LeftBarSubCategory>
            )}
            <LeftBarSubCategory onClick={() => changePage("/Organizations")}>
              Organizations
            </LeftBarSubCategory>
            {userPermissions.ORI.Admin && (
              <LeftBarSubCategory onClick={() => changePage("/Patients")}>
                All Patients
              </LeftBarSubCategory>
            )}
            <LeftBarSubCategory onClick={() => changePage("/Softwares")}>
              All Softwares
            </LeftBarSubCategory>
            <LeftBarSubCategory onClick={() => changePage("/Extensions")}>
              All Extensions
            </LeftBarSubCategory>
            {userPermissions.ORI.Admin && (
              <LeftBarSubCategory onClick={() => changePage("/FAQ")}>
                FAQ
              </LeftBarSubCategory>
            )}
          </Category>
        )}

        {userPermissions.OrgClinical.length > 0 &&
          userPermissions.ORI.Admin === false && (
            <Category>
              <LeftBarCategory>Clinical</LeftBarCategory>
              <LeftBarSubCategory onClick={() => changePage("/Patients")}>
                Patients
              </LeftBarSubCategory>
            </Category>
          )}

        {userPermissions.OrgDeveloper.length > 0 &&
          userPermissions.ORI.Admin === false && (
            <Category>
              <LeftBarCategory>Softwares</LeftBarCategory>
              <LeftBarSubCategory onClick={() => changePage("/Softwares")}>
                My Organization softwares
              </LeftBarSubCategory>
            </Category>
          )}

        <ThemeSwitch>
          <MaterialUISwitch
            sx={{ m: 1 }}
            onClick={(event: any) => setDarkMode(event.target.checked)}
          />
        </ThemeSwitch>
      </LeftBar>
    </NavBarBody>
  );
};

export default NavBar;
